<template>
  <div class="full-width">
    <q-input
      ref="input"
      v-model="currentValue"
      :placeholder="placeholder ? placeholder : 'Search'"
      outlined
      dense
      bg-color="white"
      :debounce="debounce"
    >
      <template v-slot:prepend>
        <Icon name="search" />
      </template>

      <template v-if="currentValue" v-slot:append>
        <q-icon name="cancel" @click.stop="currentValue = ''" class="cursor-pointer" />
      </template>
    </q-input>
  </div>
</template>

<script>
import Icon from './Icon';

export default {
  name: 'SearchBar',
  components: { Icon },
  props: {
    value: { type: [String, Number] },
    placeholder: { type: String },
    debounce: { type: String, default: '300' },
  },
  computed: {
    currentValue: {
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
